/*
 * Extract a best-effort BCP 47 locale tag in both Web and Electron renderers.
 *
 * Falls back to "en-US" if nothing reliable is available.
 */

import { Languages } from "@/utils/languages";

export const locale = {
  gets(): Languages.Tag[] {
    try {
      const languages =
        Array.isArray(navigator.languages) && navigator.languages.length > 0
          ? navigator.languages
          : [navigator.language];
      const list = languages.filter((language) => Boolean(language));
      return list.length > 0 ? list : ["en-US"];
    } catch {
      return ["en-US"];
    }
  },

  get(): Languages.Tag {
    return this.gets()[0] || "en-US";
  },

  /**
   * Normalize a locale-like string:
   * - trim/empty guard
   * - ensure basic casing (ll-RR style)
   */
  normalize(tag: string | null | undefined): Languages.Tag {
    if (!tag) return "en-US";
    const trimmed = String(tag).trim();
    if (!trimmed) return "en-US";
    // Basic normalization: split language/region/script and adjust casing
    const parts = trimmed.replace("_", "-").split("-");
    if (parts.length === 1) return parts[0].toLowerCase();
    const [lang, regionOrScript, ...rest] = parts;
    const normalized =
      regionOrScript && regionOrScript.length === 2
        ? `${lang.toLowerCase()}-${regionOrScript.toUpperCase()}`
        : `${lang.toLowerCase()}-${regionOrScript}`;
    return rest.length > 0 ? [normalized, ...rest].join("-") : normalized;
  },
};
